import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class ReminderDelete extends AbstractRequestTask {

  constructor(reminder_id = '') {
    super();
      this.reminder_id = reminder_id;
  }

  getHeaders() {
    return {};
  }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");

      return `${http}${url}/services/user/v1/reminder/delete`;
    }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    const reminder_id = this.reminder_id;
    return Object.assign({}, params, { reminder_id });
  }

    isValid(data) {
        if (data.errors || data.status == 1 || data.response === 'error') {
            return false;
        }
        return true;
    }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default ReminderDelete;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ReminderDeleteTask.js